import React from 'react';

import { useSearchOimContact } from '../../modules/OimApiProxy';

import { SearchCustomersPanel } from './SearchCustomersPanel';
import { PanelConfig } from './types';

export const oimApiContactPanelConfig: PanelConfig = {
    title: 'Search OIM API | Contact Endpoint',
    filters: [
      { label: 'Email', name: 'email', optional: true },
      { label: 'Phone', name: 'phone', optional: true },
    ],
    url: '/relationships-api-proxy/oim-contact',
    queryKeys: ['email', 'phone'],
  };

export function SearchOimApiCustomersPanel() {
  return <SearchCustomersPanel key={oimApiContactPanelConfig.title} config={oimApiContactPanelConfig} useQueryHook={useSearchOimContact} />
};
